import http from './http';

enum Api {
	testApi = '/auth/social',
}

/**
 * @description: get banners data info api
 */

export async function getTestApi(params: any) {
	return await http.post(Api.testApi, params);
}
